import { getPresetPreviewVideo } from './schedule';

interface EscalatorPreviewBackgroundProps {
  preset?: number;
  muted: boolean;
}

export function EscalatorPreviewBackground({ preset = 1, muted }: EscalatorPreviewBackgroundProps) {
  return (
    <video
      className="escalator-preview-background"
      src={getPresetPreviewVideo(preset)}
      autoPlay
      loop
      muted={muted}
      playsInline
    />
  );
}
